import { IDataRepublic } from '@/features/monitoring/models/IMonitoring';

const MONTHS_ORDER = [
  'JANUARY',
  'FEBRUARY',
  'MARCH',
  'APRIL',
  'MAY',
  'JUNE',
  'JULY',
  'AUGUST',
  'SEPTEMBER',
  'OCTOBER',
  'NOVEMBER',
  'DECEMBER',
];
export default function useTable() {
  const allMonths = (data: (IDataRepublic | undefined)[]) =>
    Array.from(
      new Set(
        data
          .flatMap((region) => region?.inspected_area || [])
          .filter(Boolean)
          .map((item) => item.month),
      ),
    ).sort((a, b) => MONTHS_ORDER.indexOf(a) - MONTHS_ORDER.indexOf(b));

  const getActionsByMonth = (
    month: string,
    data: (IDataRepublic | undefined)[],
  ) => {
    const actions = new Map<string, { action_name: string; planting_type?: string }>();
    data.forEach((region) => {
      (region?.inspected_area || [])
        .filter((item) => item?.month === month)
        .forEach((item) => {
          if (item.action_name) {
            const key = `${item.action_name}-${item.planting_type || ''}`;
            actions.set(key, { action_name: item.action_name, planting_type: item.planting_type as string });
          }
        });
    });
    return Array.from(actions.values());
  };

  const getValue = (
    region: IDataRepublic | undefined,
    month?: string,
    actionName?: string,
    plantingType?: string,
  ): string => {
    const action = region?.inspected_area?.find(
      (item) => item?.month === month && item?.action_name === actionName && (item?.planting_type || '') === (plantingType || ''),
    );
    return Number(action?.inspected_area || 0).toFixed(2);
  };

  return { getValue, getActionsByMonth, allMonths };
}
